/**
 * @description Embed Type Smart Tag is embedded by
 */
export enum EmbedType {
	DESKTOP = 'DESKTOP',
	MOBILE_WEB = 'MOBILE_WEB',
	HTML5 = 'HTML5'
}